import { useEffect, useState } from 'react'
import { syncFailuresApi, type SyncFailure } from '../crmApi'
import { ApiError } from '../api'

const ENTITY_LABEL: Record<string, string> = {
  Customer: 'Kund',
  Product: 'Produkt',
  DeliveryOccasion: 'Leveranstillfälle',
  Order: 'Order',
}

export function SyncFailures() {
  const [rows, setRows] = useState<SyncFailure[]>([])
  const [includeResolved, setIncludeResolved] = useState(false)
  const [loading, setLoading] = useState(false)
  const [busy, setBusy] = useState<number | null>(null)
  const [error, setError] = useState<string | null>(null)

  const fail = (e: unknown) => setError(e instanceof ApiError ? `Fel ${e.status}: ${e.body}` : String(e))

  useEffect(() => { void reload() }, [includeResolved])

  async function reload() {
    setLoading(true)
    try { setRows(await syncFailuresApi.list(includeResolved)); setError(null) }
    catch (e) { fail(e) }
    finally { setLoading(false) }
  }

  async function dismiss(id: number) {
    setBusy(id)
    try { await syncFailuresApi.dismiss(id); await reload() }
    catch (e) { fail(e) } finally { setBusy(null) }
  }

  return (
    <div>
      <h1>Synk-fel</h1>
      <p className="muted">
        Lokala uppdateringar som misslyckades när data hämtades från Multisoft via passthrough.
        Själva passthrough-anropet påverkas aldrig — det som inte kunde sparas i CRM:et listas här.
      </p>
      {error && <p className="error">{error}</p>}

      <div className="card filters">
        <label>
          <input type="checkbox" checked={includeResolved}
            onChange={(e) => setIncludeResolved(e.target.checked)} />{' '}
          Visa avfärdade
        </label>
        <button onClick={() => void reload()} disabled={loading}>Uppdatera</button>
      </div>

      {loading ? <p className="muted">Laddar…</p> : (
        <table className="grid">
          <thead>
            <tr>
              <th>Tidpunkt</th><th>Typ</th><th>Nyckel</th><th>Kund (Multisoft)</th>
              <th>Källa</th><th>Fel</th><th>Åtgärder</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((f) => (
              <tr key={f.id} className={f.isResolved ? 'muted' : undefined}>
                <td>{new Date(f.createdUtc).toLocaleString('sv-SE')}</td>
                <td>{ENTITY_LABEL[f.entity] ?? f.entity}</td>
                <td>{f.externalKey ?? '—'}</td>
                <td>{f.customerIdWsOrder ?? '—'}</td>
                <td>{f.operation}</td>
                <td>{f.error}</td>
                <td className="actions">
                  {f.isResolved
                    ? <span className="muted">Avfärdad</span>
                    : <button disabled={busy === f.id} onClick={() => void dismiss(f.id)}>Avfärda</button>}
                </td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan={7} className="muted">Inga synk-fel{includeResolved ? '' : ' att åtgärda'}.</td></tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  )
}
